<template>
    <div class="grid max-w-xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="checkAll"
            class="border-b border-gray-300 pb-4 font-semibold"
            :label="$t('acknowledgements.check_all')"
            name="account.acknowledgements.check_all"></BaseInputCheckbox>
        <LegalAcknowledgementsTwoFormFields v-model="formValues"></LegalAcknowledgementsTwoFormFields>
    </div>
</template>

<script setup lang="ts">
import BaseInputCheckbox from '../../../../base/BaseInputCheckbox.vue'
import { computed } from 'vue'
import { getLegalWidgetFormValidationRules, initializeLegalWidgetForm, LegalAcknowledgmentsTwo } from './forms'
import LegalAcknowledgementsTwoFormFields from './acknowledgements/LegalAcknowledgementsTwoFormFields.vue'
import { useVModel } from '@vueuse/core'

const formTwoFields: string[] = Object.keys(new LegalAcknowledgmentsTwo()).map((key) => 'acknowledgements.' + key)
const checkAll = computed({
    get() {
        return Object.keys(formValues.value)
            .filter((key) => Object.keys(new LegalAcknowledgmentsTwo()).includes(key))
            .every((key) => {
                return formValues.value[key]
            })
    },
    // setter
    set(newValue) {
        if (newValue) {
            Object.keys(formValues.value)
                .filter((key) => Object.keys(new LegalAcknowledgmentsTwo()).includes(key))
                .forEach((key) => {
                    formValues.value[key] = true
                })
        } else {
            Object.keys(formValues.value)
                .filter((key) => Object.keys(new LegalAcknowledgmentsTwo()).includes(key))
                .forEach((key) => {
                    formValues.value[key] = false
                })
        }
    },
})

const props = defineProps<{
    modelValue: LegalAcknowledgmentsTwo
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)

const allAcknowledgementRules = getLegalWidgetFormValidationRules('acknowledgements')
const acknowledgementsTwoFormValidations = Object.keys(allAcknowledgementRules)
    .filter((key) => formTwoFields.includes(key))
    .reduce((obj, key) => {
        obj[key] = allAcknowledgementRules[key]
        return obj
    }, {})

initializeLegalWidgetForm(acknowledgementsTwoFormValidations)
</script>
